module.exports = __webpack_public_path__ + "static/fiji2-150x150-f3541bb8c86976690138492c977ff3ee.png";